// Volume Discount Component
(function () {
    'use strict';

    function initVolumeDiscount() {
        const volumeDiscount = document.querySelector('volume-discount');
        if (!volumeDiscount) return;

        const options = volumeDiscount.querySelectorAll('.volume-discount__option');
        if (!options.length) return;

        const productForm = volumeDiscount.closest('product-form') || document.querySelector('product-form');
        let selectedQuantity = 1;

        function selectOption(option) {
            options.forEach(opt => opt.classList.remove('selected'));
            option.classList.add('selected');

            const quantity = parseInt(option.dataset.quantity) || 1;
            selectedQuantity = quantity;

            if (productForm) {
                const input = productForm.querySelector('[name="quantity"]') ||
                    document.querySelector('input[type="number"][name="quantity"]');
                if (input) {
                    input.value = quantity;
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }

            try {
                const variantSelects = document.querySelector('variant-selects');
                let currentVariant = null;

                const variantInput = productForm ? productForm.querySelector('[name="id"]') : null;
                const variantInputValue = variantInput ? variantInput.value : null;

                if (variantSelects && variantSelects.currentVariant) {
                    const currentVariantId = String(variantSelects.currentVariant.id);
                    const inputVariantId = String(variantInputValue || '');

                    if (currentVariantId === inputVariantId && inputVariantId !== '') {
                        currentVariant = variantSelects.currentVariant;
                    }
                }

                if (!currentVariant && variantInputValue) {
                    const variantSelectsEl = document.querySelector('variant-selects');
                    try {
                        let variantJsonElement = null;
                        if (variantSelectsEl) {
                            variantJsonElement = variantSelectsEl.querySelector('[type="application/json"]');
                        }
                        if (!variantJsonElement) {
                            variantJsonElement = document.querySelector('[data-variant-json]');
                        }
                        if (variantJsonElement) {
                            const variantData = JSON.parse(variantJsonElement.textContent);
                            currentVariant = variantData.find(v => String(v.id) === String(variantInputValue));
                        }
                    } catch (e) {
                        console.error('[Volume Discount] Error parsing variant data:', e);
                    }
                }

                if (!currentVariant) {
                    console.warn('[Volume Discount] No variant found! Cannot update price.');
                }

                updatePrice(quantity);
                updateIndependentButtonPrice(currentVariant);
            } catch (error) {
                console.error('[Volume Discount] Error in selectOption:', error);
                updatePrice(quantity);
                updateIndependentButtonPrice(null);
            }
        }

        selectOption(options[0]);

        options.forEach((option) => {
            option.style.cursor = 'pointer';
            option.style.pointerEvents = 'auto';

            option.onclick = function (e) {
                e.preventDefault();
                e.stopPropagation();
                selectOption(option);
                return false;
            };
        });

        const container = volumeDiscount.querySelector('.volume-discount__options');
        if (container) {
            container.addEventListener('click', function (e) {
                const option = e.target.closest('.volume-discount__option');
                if (option) {
                    e.preventDefault();
                    e.stopPropagation();
                    selectOption(option);
                }
            }, true);
        }

        setupCartInterception();
        initIndependentAddToCartButton();
    }

    function initIndependentAddToCartButton() {
        const volumeDiscount = document.querySelector('volume-discount');
        if (!volumeDiscount) return;

        const atcButton = volumeDiscount.querySelector('[data-volume-discount-atc]');
        const priceElement = volumeDiscount.querySelector('[data-volume-discount-price]');
        if (!atcButton || !priceElement) return;

        updateIndependentButtonPrice();

        document.addEventListener('variant:change', function (event) {
            if (event.detail && event.detail.variant) {
                updateIndependentButtonPrice(event.detail.variant);
            }
        });

        const volumeDiscountObserver = new MutationObserver(function () {
            updateIndependentButtonPrice();
        });

        const optionsContainer = volumeDiscount.querySelector('.volume-discount__options');
        if (optionsContainer) {
            volumeDiscountObserver.observe(optionsContainer, {
                attributes: true,
                attributeFilter: ['class'],
                subtree: true
            });
        }

        atcButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (atcButton.disabled) return;

            const selectedOption = volumeDiscount.querySelector('.volume-discount__option.selected');
            if (!selectedOption) return;

            const quantity = parseInt(selectedOption.dataset.quantity) || 1;
            addToCartWithQuantity(quantity, atcButton);
        });
    }

    function updateIndependentButtonPrice(variant) {
        const volumeDiscount = document.querySelector('volume-discount');
        if (!volumeDiscount) return;

        const priceElement = volumeDiscount.querySelector('[data-volume-discount-price]');
        const atcButton = volumeDiscount.querySelector('[data-volume-discount-atc]');
        if (!priceElement || !atcButton) return;

        let currentVariant = variant;

        if (!currentVariant) {
            const variantSelects = document.querySelector('variant-selects');
            const productForm = document.querySelector('product-form');
            const variantInput = productForm ? productForm.querySelector('[name="id"]') : null;
            const variantInputValue = variantInput ? variantInput.value : null;

            if (variantSelects && variantSelects.currentVariant && variantInputValue) {
                const currentVariantId = String(variantSelects.currentVariant.id);
                const inputVariantId = String(variantInputValue);

                if (currentVariantId === inputVariantId) {
                    currentVariant = variantSelects.currentVariant;
                }
            }

            if (!currentVariant && variantInputValue) {
                const variantSelectsEl = document.querySelector('variant-selects');
                try {
                    let variantJsonElement = null;
                    if (variantSelectsEl) {
                        variantJsonElement = variantSelectsEl.querySelector('[type="application/json"]');
                    }
                    if (!variantJsonElement) {
                        variantJsonElement = document.querySelector('[data-variant-json]');
                    }
                    if (variantJsonElement) {
                        const variantData = JSON.parse(variantJsonElement.textContent);
                        currentVariant = variantData.find(v => String(v.id) === String(variantInputValue));
                    }
                } catch (e) {
                    console.error('[Volume Discount] Error parsing variant data in updateIndependentButtonPrice:', e);
                }
            }
        }

        if (!currentVariant || !currentVariant.price) {
            const productForm = document.querySelector('product-form');
            if (productForm) {
                const variantInput = productForm.querySelector('[name="id"]');
                if (variantInput && variantInput.value) {
                    const variantSelectsEl = document.querySelector('variant-selects');
                    try {
                        let variantJsonElement = null;
                        if (variantSelectsEl) {
                            variantJsonElement = variantSelectsEl.querySelector('[type="application/json"]');
                        }
                        if (!variantJsonElement) {
                            variantJsonElement = document.querySelector('[data-variant-json]');
                        }
                        if (variantJsonElement) {
                            const variantData = JSON.parse(variantJsonElement.textContent);
                            currentVariant = variantData.find(v => v.id == variantInput.value);
                        }
                    } catch (e) {
                        console.error('Error parsing variant data:', e);
                    }
                }
            }
        }

        if (!currentVariant || !currentVariant.price) {
            const productForm = document.querySelector('product-form');
            if (productForm) {
                const priceEl = productForm.querySelector('.price-item--regular, .price__regular');
                if (priceEl) {
                    const text = priceEl.textContent.trim();
                    const price = parseFloat(text.replace(/[^0-9.,]/g, '').replace(',', '.')) * 100;
                    if (price) {
                        currentVariant = { price: price };
                    }
                }
            }
        }

        if (!currentVariant || !currentVariant.price) return;

        const selectedOption = volumeDiscount.querySelector('.volume-discount__option.selected');
        const quantity = selectedOption ? parseInt(selectedOption.dataset.quantity) || 1 : 1;

        const payQuantity = calculatePayQuantity(quantity);

        const totalPrice = currentVariant.price * payQuantity;

        const moneyFormat = window.theme?.shopSettings?.moneyFormat ||
            window.Shopify?.theme?.moneyFormat ||
            '${{amount}}';

        if (window.Shopify && window.Shopify.formatMoney) {
            priceElement.textContent = window.Shopify.formatMoney(totalPrice, moneyFormat);
        } else if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
            priceElement.textContent = window.theme.Currency.formatMoney(totalPrice, moneyFormat);
        } else {
            const formattedPrice = (totalPrice / 100).toFixed(2);
            priceElement.textContent = moneyFormat.replace('{{amount}}', formattedPrice);
        }

        if (currentVariant.available === false) {
            atcButton.disabled = true;
        } else {
            atcButton.disabled = false;
        }
    }

    function addToCartWithQuantity(quantity, button) {
        const productForm = document.querySelector('product-form');
        if (!productForm) return;

        const variantInput = productForm.querySelector('[name="id"]');
        if (!variantInput || !variantInput.value) return;

        const variantId = variantInput.value;
        const miniCart = document.querySelector('mini-cart');

        button.disabled = true;
        button.classList.add('loading');

        const sections = miniCart
            ? miniCart.getSectionsToRender().map((section) => section.id)
            : [];

        const body = JSON.stringify({
            id: variantId,
            quantity: quantity,
            sections: sections,
            sections_url: window.location.pathname,
        });

        let config;
        if (typeof fetchConfig === 'function') {
            config = fetchConfig('javascript');
        } else if (window.theme && window.theme.fetchConfig) {
            config = window.theme.fetchConfig('javascript');
        } else {
            config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            };
        }

        const cartAddUrl = window.theme?.routes?.cart_add_url || '/cart/add.js';

        fetch(cartAddUrl, {
            ...config,
            body,
        })
            .then((response) => response.json())
            .then((parsedState) => {
                if (parsedState.status === 422) {
                    document.dispatchEvent(
                        new CustomEvent('ajaxProduct:error', {
                            detail: {
                                errorMessage: parsedState.description,
                            },
                        })
                    );
                } else {
                    if (miniCart) {
                        miniCart.renderContents(parsedState);
                    }

                    document.dispatchEvent(
                        new CustomEvent('ajaxProduct:added', {
                            detail: {
                                product: parsedState,
                            },
                        })
                    );
                }
            })
            .catch((e) => {
                console.error('Error adding to cart:', e);
                document.dispatchEvent(
                    new CustomEvent('ajaxProduct:error', {
                        detail: {
                            errorMessage: 'Erro ao adicionar produto ao carrinho',
                        },
                    })
                );
            })
            .finally(() => {
                button.classList.remove('loading');
                button.disabled = false;
            });
    }

    /**
     * Calculate the quantity to pay based on the selected quantity
     * The selected quantity is the total products received, but we only pay for some of them
     * Examples:
     * - 1 product = pay for 1
     * - 3 products (Buy 2 Get 1 Free) = pay for 2
     * - 5 products (Buy 3 Get 2 Free) = pay for 3
     * 
     * Pattern: For "Buy X Get Y Free" where total = X + Y:
     * - If total = 3, it's "Buy 2 Get 1" → pay for 2
     * - If total = 5, it's "Buy 3 Get 2" → pay for 3
     * 
     * General formula for "Buy N Get (N-1) Free": total = 2N-1, pay = N
     * So: pay = (total + 1) / 2 when total follows this pattern
     */
    function calculatePayQuantity(selectedQuantity) {
        // If quantity is 1, pay for 1 (no discount)
        if (selectedQuantity === 1) {
            return 1;
        }

        // For 3 products (Buy 2 Get 1 Free), pay for 2
        if (selectedQuantity === 3) {
            return 2;
        }

        // For 5 products (Buy 3 Get 2 Free), pay for 3
        if (selectedQuantity === 5) {
            return 3;
        }

        // For 9 products (Buy 6 Get 3 Free), pay for 6
        if (selectedQuantity === 9) {
            return 6;
        }

        // Check if it follows the "Buy N Get (N-1) Free" pattern: total = 2N-1
        // This means: if (selectedQuantity + 1) is even, we can calculate
        if ((selectedQuantity + 1) % 2 === 0) {
            const calculatedPay = (selectedQuantity + 1) / 2;
            // Verify the pattern: if we pay for N, we get (N-1) free
            // Total = N + (N-1) = 2N - 1
            // So if selectedQuantity = 2N - 1, then pay = N = (selectedQuantity + 1) / 2
            if (2 * calculatedPay - 1 === selectedQuantity) {
                return calculatedPay;
            }
        }

        // For quantity 2, pay for 2 (no discount)
        if (selectedQuantity === 2) {
            return 2;
        }

        // Default fallback: if no pattern matches, pay for all
        // This handles edge cases where the discount pattern is different
        return selectedQuantity;
    }

    function updatePrice(quantity) {
        const productForm = document.querySelector('product-form');
        if (!productForm) return;

        let currentVariant = null;
        const variantInput = productForm.querySelector('[name="id"]');
        const variantInputValue = variantInput ? variantInput.value : null;

        if (variantInputValue) {
            const variantSelects = document.querySelector('variant-selects');

            if (variantSelects && variantSelects.currentVariant) {
                const currentVariantId = String(variantSelects.currentVariant.id);
                const inputVariantId = String(variantInputValue);

                if (currentVariantId === inputVariantId) {
                    currentVariant = variantSelects.currentVariant;
                }
            }

            if (!currentVariant) {
                const variantSelectsEl = document.querySelector('variant-selects');
                try {
                    let variantJsonElement = null;
                    if (variantSelectsEl) {
                        variantJsonElement = variantSelectsEl.querySelector('[type="application/json"]');
                    }
                    if (!variantJsonElement) {
                        variantJsonElement = document.querySelector('[data-variant-json]');
                    }
                    if (variantJsonElement) {
                        const variantData = JSON.parse(variantJsonElement.textContent);
                        currentVariant = variantData.find(v => String(v.id) === String(variantInputValue));
                    }
                } catch (e) {
                    console.error('[Volume Discount] updatePrice - Error parsing variant data:', e);
                }
            }
        }

        if (!currentVariant || !currentVariant.price) {
            const priceEl = productForm.querySelector('.price-item--regular, .price__regular');
            if (priceEl) {
                const text = priceEl.textContent.trim();
                const price = parseFloat(text.replace(/[^0-9.,]/g, '').replace(',', '.')) * 100;
                if (price) {
                    currentVariant = { price: price };
                }
            }
        }

        if (!currentVariant || !currentVariant.price || !window.Shopify?.formatMoney) return;

        const payQuantity = calculatePayQuantity(quantity);
        const total = currentVariant.price * payQuantity;
        const format = window.theme?.shopSettings?.moneyFormat ||
            window.theme?.moneyFormat ||
            '${{amount}}';

        document.querySelectorAll('.product-form__submit .add-to-cart-price').forEach(span => {
            span.textContent = window.Shopify.formatMoney(total, format);
        });

        const stickyPrice = document.querySelector('.sticky-add-to-cart__button .add-to-cart-price');
        if (stickyPrice) {
            stickyPrice.textContent = window.Shopify.formatMoney(total, format);
        }

        updateIndependentButtonPrice();
    }

    function setupCartInterception() {
        if (window.__volumeDiscountFetchIntercepted) return;
        window.__volumeDiscountFetchIntercepted = true;

        const originalFetch = window.fetch;
        window.fetch = function (...args) {
            const [url, options = {}] = args;

            if (typeof url === 'string' && url.includes('/cart/add')) {
                const activeOption = document.querySelector('volume-discount .volume-discount__option.selected');
                if (activeOption) {
                    const qty = parseInt(activeOption.dataset.quantity) || 1;

                    if (options.body instanceof FormData) {
                        options.body.delete('quantity');
                        options.body.append('quantity', qty);
                    } else if (typeof options.body === 'string') {
                        try {
                            const body = JSON.parse(options.body);
                            if (body.quantity !== undefined) {
                                body.quantity = qty;
                                options.body = JSON.stringify(body);
                            }
                        } catch (e) {
                        }
                    }
                }
            }

            return originalFetch.apply(this, args);
        };
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initVolumeDiscount);
    } else {
        initVolumeDiscount();
    }

    setTimeout(initVolumeDiscount, 500);
})();






